import { type PerspectiveSublevel } from '@/routes/perspectives/types';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import Dialog from '@/components/Dialog';
import api from '@/lib/api';
import useRefreshPerspectives from '../../useRefreshPerspectives';
import useIsDeletable from '../../useIsDeletable';

type DeletePerspectiveSublevelProps = {
  perspectiveSublevel: PerspectiveSublevel;
};

const DeletePerspectiveSublevel = ({
  perspectiveSublevel,
}: DeletePerspectiveSublevelProps) => {
  const refreshPerspectives = useRefreshPerspectives();

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setConfirmationDialogOpen(false);

    setDeleting(true);

    await api.delete(`/perspectives/sublevels/${perspectiveSublevel.id}`);

    await refreshPerspectives();

    setDeleting(false);
  };

  const perspectiveSublevelIsDeletable = useIsDeletable(
    perspectiveSublevel._count.children,
    perspectiveSublevel._count.attachedTasks,
  );

  if (!perspectiveSublevelIsDeletable) {
    return null;
  }

  return (
    <>
      <IconButton
        className="visible-on-hover"
        color="error"
        size="small"
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <DeleteIcon />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
      >
        <Dialog.Title>Are you sure?</Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <strong>{perspectiveSublevel.name}</strong> will become permanently
            unavailable for all Egodact users. This action cannot be reversed.
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={handleDelete} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeletePerspectiveSublevel;
